import { generateAutomationName } from "../../helpers/generateAutomationName";

export const statesDataAutomation = {
    empty: generateAutomationName("home", ["projects", "list", "empty"]),
    error: generateAutomationName("home", ["projects", "list", "error"]),
    emptyButton: generateAutomationName("home", ["projects", "list", "empty", "button"]),
    emptyList: generateAutomationName("home", ["projects", "list", "emptyList"]),
};

export const listDataAutomation = {
    list: generateAutomationName("home", ["projects", "list"]),
    listHeader: generateAutomationName("home", ["projects", "list", "header"]),
    searchInput: generateAutomationName("home", ["projects", "list", "searchInput"]),
};
